module.exports = __webpack_public_path__ + "static/media/AllStop.af767242.pdf";